<form [formGroup]="form">
    <ng-select class="custom sg-rounded"
               [class.sg-select__shadow]="shadow"
               [class.sg-select__no-border]="noBorder"
               [class.sg-select__errors]="errors.length > 0"
               [items]="options"
               formControlName="select"
               [clearable]="clearable"
               [searchable]="false"
               [placeholder]="placeholder"
               bindLabel="description">
        <ng-template ng-label-tmp let-item="item">
            <div class="d-flex flex-row" [class.sg-select__placeholder]="!item.data">
                <div *ngIf="item.icon" class="d-flex">
                    <div class="select-icon text-center"><mlp-ng-icon [name]="item.icon"></mlp-ng-icon></div>
                    <div class="ml-2 mr-2 select-divider"></div>
                </div>
                <div class="ml-1">{{item.description}}</div>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="d-flex flex-row" [class.sg-select__placeholder]="!item.data">
                <span class="mr-2 pr-1" *ngIf="item.icon"><mlp-ng-icon [name]="item.icon"></mlp-ng-icon></span>
                <div>{{item.description}}</div>
            </div>
        </ng-template>
    </ng-select>
    <small class="form-text sg-color__danger" *ngFor="let error of errors">{{ error.title }}</small>
</form>
